import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, List, ListItem, ListItemText,
  CircularProgress, Typography, Box, Chip, InputAdornment
} from '@mui/material';
import { Search } from '@mui/icons-material';
import axios from 'axios';
import API_URL from '../../../../config/api';

export default function BuscaRapidaStatus({ open, onClose, onSelectAluguel }) {
  const [busca, setBusca] = useState('');
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscaRealizada, setBuscaRealizada] = useState(false);

  const handleBuscar = async () => {
    setLoading(true);
    setBuscaRealizada(true);
    try {
      const token = localStorage.getItem('token');
      
      // Buscar todos os aluguéis que não estão finalizados
      const res = await axios.get(`${API_URL}/alugueis/relatorios`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('Total de aluguéis retornados:', res.data.length);
      console.log('Aluguéis:', res.data);

      // Se não digitou nada, mostra todos os não finalizados
      if (!busca.trim()) {
        const naoFinalizados = res.data.filter(a => a.status_aluguel !== 'Finalizado');
        console.log('Mostrando todos os não finalizados:', naoFinalizados.length);
        setResultados(naoFinalizados);
        return;
      }

      // Filtrar localmente por cliente, placa, ID ou modelo
      const termo = busca.toLowerCase().trim();
      const filtrados = res.data.filter(a => {
        // Não mostrar finalizados
        if (a.status_aluguel === 'Finalizado') return false;
        
        const match = (
          a.id?.toString().includes(termo) ||
          a.nome_cliente?.toLowerCase().includes(termo) ||
          a.placa?.toLowerCase().includes(termo) ||
          a.modelo?.toLowerCase().includes(termo)
        );
        
        if (match) {
          console.log('Match encontrado:', a.id, a.nome_cliente, a.status_aluguel);
        }
        
        return match;
      });

      console.log('Resultados filtrados:', filtrados.length);
      setResultados(filtrados);
    } catch (error) {
      console.error('Erro ao buscar:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBuscar();
    }
  };

  const handleSelectAluguel = (aluguel) => {
    onSelectAluguel(aluguel);
    handleClose();
  };

  const handleClose = () => {
    setBusca('');
    setResultados([]);
    setBuscaRealizada(false);
    onClose();
  };

  const getStatusColor = (status) => {
    const cores = {
      'Reservado': 'info',
      'Agendado': 'info',
      'Ativo': 'success',
      'Em Andamento': 'success',
      'Atrasado': 'error',
      'Cancelado': 'default',
      'Análise': 'warning'
    };
    return cores[status] || 'default';
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        ⚡ Busca Rápida - Trocar Status
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Busque por: Nome do cliente, Placa, Modelo ou ID do aluguel
        </Typography>

        <TextField
          fullWidth
          placeholder="Digite para buscar..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          onKeyPress={handleKeyPress}
          autoFocus
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <Box display="flex" gap={1} mb={3}>
          <Button
            variant="contained"
            onClick={handleBuscar}
            disabled={loading}
            fullWidth
          >
            {loading ? <CircularProgress size={24} /> : 'Buscar'}
          </Button>
          
          <Button
            variant="outlined"
            onClick={handleBuscar}
            disabled={loading}
            fullWidth
          >
            Ver Todos Ativos
          </Button>
        </Box>

        {loading && (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress />
          </Box>
        )}

        {!loading && buscaRealizada && resultados.length === 0 && (
          <Typography variant="body2" color="text.secondary" align="center" py={3}>
            Nenhum aluguel encontrado com "{busca}"
          </Typography>
        )}

        {!loading && resultados.length > 0 && (
          <>
            <Typography variant="subtitle2" color="primary" sx={{ mb: 1 }}>
              {resultados.length} resultado(s) encontrado(s):
            </Typography>
            
            <List sx={{ maxHeight: 400, overflow: 'auto' }}>
              {resultados.map((aluguel) => (
                <ListItem
                  key={aluguel.id}
                  button
                  onClick={() => handleSelectAluguel(aluguel)}
                  sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    mb: 1,
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                      borderColor: '#FF8C00'
                    }
                  }}
                >
                  <ListItemText
                    primary={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="subtitle2">
                          #{aluguel.id} - {aluguel.nome_cliente}
                        </Typography>
                        <Chip
                          label={aluguel.status_aluguel}
                          color={getStatusColor(aluguel.status_aluguel)}
                          size="small"
                        />
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2" component="span">
                          🚗 {aluguel.placa} - {aluguel.modelo}
                        </Typography>
                        <br />
                        <Typography variant="caption" color="text.secondary">
                          Retirada: {new Date(aluguel.data_retirada).toLocaleDateString('pt-BR')} | 
                          Devolução: {new Date(aluguel.data_devolucao).toLocaleDateString('pt-BR')}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
